function t({pad:t,maxLen:a},n){return t?"start"===t.position?n.padStart(a,t.with):n.padEnd(a,t.with):n}export{t as padString};
